export default __webpack_public_path__ + "static/media/connectus-on-white.399bb9f3.png";